<script lang="ts">
	import { ButtonGroup, Button } from '@Shelly/shelly-design-system/index';
	import { format } from 'svelte-i18n';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { saveDeviceListSettings } from 'src/helpers/home_helpers';
	import type { DeviceListLayoutType } from 'src/helpers/new-layout-helpers';
	import { home_data } from 'src/stores/account/user';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import { deviceTableViewAvailable } from 'src/stores/features/dev/device-table-view';

	export let disabled = false;

	let deviceListType: DeviceListLayoutType = $home_data?.['device_list']?.type || 'default';
	$: deviceListType = ($home_data?.['device_list']?.type as DeviceListLayoutType) || 'default';

	const onChangeDeviceListType = async (type: DeviceListLayoutType = 'default') => {
		if (disabled) return;
		if (deviceListType === type) return;

		const cached = deviceListType;
		deviceListType = type;

		const res = await saveDeviceListSettings({ type });

		if (!res.isok) {
			deviceListType = cached;
		}

		onSettingsResponse(res);
	};
</script>

{#if $showNewLayout}
	<ButtonGroup aria-label="Button group" class="pt-0 pb-0 pl-0 pr-0">
		<Button
			aria-label={$format('label_list_view', { default: 'List view' })}
			class={deviceListType === 'default' ? 'active' : undefined}
			size="m"
			icon="fas fa-list"
			leftIconSize="xs"
			{disabled}
			on:click={async () => {
				await onChangeDeviceListType('default');
			}}
		/>
		<Button
			aria-label={$format('label_grid_view', { default: 'Grid view' })}
			class={deviceListType === 'compact' ? 'active' : undefined}
			size="m"
			icon="fas fa-grid-2"
			leftIconSize="xs"
			{disabled}
			on:click={async () => {
				await onChangeDeviceListType('compact');
			}}
		/>
		{#if $deviceTableViewAvailable}
			<Button
				aria-label={$format('label_table_view', { default: 'Table view' })}
				class={deviceListType === 'table' ? 'active' : undefined}
				size="m"
				icon="fas fa-table"
				leftIconSize="xs"
				{disabled}
				on:click={async () => {
					await onChangeDeviceListType('table');
				}}
			/>
		{/if}
	</ButtonGroup>
{/if}
